export class QuickFilters {
  name: string;
  code: string;
}

export class DropdownOption<T = any> {
  value: T;
  label: string;
}
